// Module
var code = "<!-- <button\nclass=\"btn btn-primary\"\nng-click=\"$ctrl.doLog()\">LOG\n</button> -->\n<!-- <div class='calendar' calendar=\"{{$ctrl.calendarId}}\" ui-calendar=\"$ctrl.calendarOptions\" ng-model=\"$ctrl.eventSources\"></div> -->\n<div class=\"\" id=\"{{$ctrl.calendarId}}\">\n\n</div>\n";
// Exports
module.exports = code;